import { createGlobalStyle } from "styled-components";

export const GlobalStyled = createGlobalStyle`
    body{
        margin: 0;
        padding: 0;
    }
`
